export class Search {
	static readonly type = '[fireInsuranceCompanySearch] search';
	constructor(public searchTerm: string) {}
}
